import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';

export interface CheckBoxUIProps extends WrappedFieldProps {
    id?: string;
    labelText: string;
    isHidden?: boolean;
}

const CheckBoxUI: React.FC<CheckBoxUIProps> = ({ input, id, labelText, isHidden, meta }: CheckBoxUIProps) => {
    if (!labelText) return null;
    let className;
    if (isHidden) {
        className = 'hidden';
    }

    const valid = meta?.submitFailed && !meta?.valid ? 'is-invalid' : '';
    const checked = input?.value === 'checked' ? true : false;

    return (
        <div className={`checkbox ${valid}`} id={id}>
            <label>
                <input {...input} type="checkbox" className={className} checked={checked} /> {labelText}
            </label>
        </div>
    );
};

export default CheckBoxUI;
